/**
 * bundle-firmenkunden.js
 * ---------------------------------------------------------------------------
 * Custom Element <bundle-firmenkunden-builder>, powers sections/bundle-firmenkunden.liquid
 * (Template product.bundle-firmenkunden.json). Bewusst eigenstaendig und ohne
 * Abhaengigkeit von jQuery/localStorage (anders als der alte
 * tzn_hupsi_paket-zusammenstellen.js-Ansatz) - reiner Vanilla-JS-Custom-Element,
 * konsistent mit dem Rest des Themes (variant-configurator.liquid, tzn_progress-bar.js).
 *
 * Ablauf (siehe Kommentar in der Section):
 *   1) Boxgroesse waehlen
 *   2) Paket aus der Kollektion zusammenstellen (bis Boxgroesse erreicht)
 *   3) Stueckzahl der Pakete waehlen
 *   4) Individualisierung (Aufkleber / Banderole / Kartenbeilage / Karte mit
 *      Gestaltung), Menge defaultet auf die Stueckzahl aus Schritt 3, ist
 *      aber frei aenderbar.
 *   5) Versand: eine Adresse (Default) oder Einzeladressen (mit manuell
 *      eingegebener Adressanzahl + Datei-Upload der Adressliste, siehe
 *      _addShippingFeeLine - bewusst KEINE automatische Auswertung der
 *      Datei, Ringos Entscheidung 27.09.2026).
 *
 * Beim Hinzufuegen zum Warenkorb bekommt jede Zeile (Box-Komponenten UND
 * Individualisierungs-Artikel) dieselbe "_set_id"-Property (analog zum
 * bestehenden Muster aus variant-configurator.liquid), damit die vorhandene
 * Cart-Drawer-Gruppierung (snippets/bundle-item.liquid) die Konfiguration als
 * eine Einheit anzeigen kann. "_bundle_kind: firmenkunden" unterscheidet diese
 * Konfigurationen von den alten Paket-Bundles mit echtem Anker-Produkt.
 *
 * Nach erfolgreichem Hinzufuegen wird der komplette Zustand zurueckgesetzt,
 * damit der Kunde sofort eine weitere Boxgroesse zusammenstellen kann - die
 * vorherige Konfiguration bleibt als eigene Gruppe im Warenkorb "geparkt".
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    var format =
      (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) ||
      '{{amount}}';

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var placeholderMatch = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands === undefined ? '.' : thousands;
      decimal = decimal === undefined ? ',' : decimal;

      if (isNaN(number) || number === null) return 0;

      number = (number / 100).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    var value;
    switch (placeholder) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }

    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  // Zentrale Liste aller Individualisierungs-Artikel (Schritt 4) - an EINER
  // Stelle gepflegt, damit ein neuer Artikel (wie "card_design"/"Karte
  // (Beilage und Gestaltung)", Markus' Anfrage vom 27.09.2026) nur hier
  // ergaenzt werden muss statt an vier verstreuten Array-Literalen.
  var INDIV_KEYS = ['sticker', 'banderole', 'card', 'card_design'];

  function uid() {
    if (window.crypto && window.crypto.randomUUID) {
      return window.crypto.randomUUID();
    }
    return 'bfk-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  // Ermittelt den fuer "qty" gueltigen Stueckpreis eines Individualisierungs-
  // Artikels (Ringos Wunsch 14.09.2026: echte Katalog-Mengenpreise statt
  // hartkodiertem Flat-Preis). itemConfig.priceBreaks kommt aus Shopifys
  // nativen "Quantity Price Breaks" (variant.quantity_price_breaks in
  // Liquid) - ein Array {minimumQuantity, price}, absteigend nach der
  // hoechsten erreichten Schwelle durchsucht. Ohne Katalog-Staffeln (Array
  // leer, z. B. weil aktuell kein zugewiesener B2B-Kunde anfragt) faellt es
  // auf itemConfig.price zurueck - identisches Verhalten wie vor diesem
  // Feature.
  function unitPriceForQty(itemConfig, qty) {
    var price = itemConfig.price;
    var breaks = itemConfig.priceBreaks;
    if (breaks && breaks.length) {
      // Hoechste erreichte Schwelle gewinnt - unabhaengig davon, ob das
      // Array (entgegen der ueblichen Shopify-Reihenfolge) nicht aufsteigend
      // sortiert ankommt.
      var bestThreshold = -1;
      for (var i = 0; i < breaks.length; i++) {
        if (qty >= breaks[i].minimumQuantity && breaks[i].minimumQuantity > bestThreshold) {
          bestThreshold = breaks[i].minimumQuantity;
          price = breaks[i].price;
        }
      }
    }
    return price;
  }

  // Identisches Schliessen-Icon wie die PDP-Produktgalerie (siehe
  // assets/theme.js.liquid, ProductGallery#photoswipe) - sorgt dafuer, dass
  // sich die Individualisierungs-Lightbox optisch nicht vom Rest des Themes
  // unterscheidet (Ringos Wunsch 10.09.2026: Beispielbilder per Klick
  // vergroessern koennen).
  var BFK_LIGHTBOX_CLOSE_SVG =
    '<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">' +
    '<path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/>' +
    '<path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/>' +
    '<path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>' +
    '</svg>';

  var BundleFirmenkundenBuilder = (function (HTMLElementBase) {
    // Echtes ES6-"class ... extends HTMLElement {}" statt der alten manuellen
    // ES5-Vererbung: native DOM-Klassen wie HTMLElement lassen sich NICHT per
    // ".call(this)" konstruieren (nur per "new"/"super()"), das fuehrte zu
    // "Failed to construct 'HTMLElement': Please use the 'new' operator" und
    // brach das gesamte Custom Element (behoben 31.08.2026).
    class BundleFirmenkundenBuilder extends HTMLElementBase {}

    BundleFirmenkundenBuilder.prototype.connectedCallback = function () {
      var configEl = document.getElementById(this.getAttribute('data-config'));
      if (!configEl) {
        console.error('[bundle-firmenkunden] config script not found');
        return;
      }

      try {
        this.config = JSON.parse(configEl.textContent);
      } catch (e) {
        console.error('[bundle-firmenkunden] invalid config JSON', e);
        return;
      }

      window.themeVariables = window.themeVariables || { settings: {} };
      if (!window.themeVariables.settings.moneyFormat) {
        window.themeVariables.settings.moneyFormat = this.config.moneyFormat || '{{amount}}';
      }

      this.state = this._freshState();

      this._cacheDom();
      this._bindEvents();
      this._renderProductGrid();
      this._updateSummary();
      this._syncSummaryBarHeight();

      // Leisten-Hoehe kann sich bei Textumbruch (langes Boxgroessen-Label
      // auf schmalen Bildschirmen) aendern - bei Resize neu vermessen.
      var self = this;
      window.addEventListener('resize', function () {
        self._syncSummaryBarHeight();
      });
    };

    // Zeigt den Stueckpreis an, der bei der AKTUELLEN Paket-Stueckzahl
    // (Schritt 3) gelten wuerde - unabhaengig davon, ob der Artikel gerade
    // aktiviert ist (dann bereits state.indiv[key] === boxQuantity) oder
    // nicht (dann state.indiv[key] === 0, aber "was wuerde es kosten" bleibt
    // die relevante Frage). Wird bei jeder _updateSummary()-Ausfuehrung neu
    // berechnet, da sich der gueltige Mengenpreis mit der Stueckzahl aendern
    // kann (Ringos Wunsch 14.09.2026: echte Katalog-Staffelpreise statt
    // Flat-Preis, siehe unitPriceForQty).
    BundleFirmenkundenBuilder.prototype._updateIndividualizationPriceLabels = function () {
      var self = this;
      this.querySelectorAll('[data-indiv-item]').forEach(function (row) {
        var key = row.getAttribute('data-indiv-item');
        var priceEl = row.querySelector('[data-indiv-price]');
        var itemConfig = self.config.individualization[key];
        if (priceEl && itemConfig) {
          var unitPrice = unitPriceForQty(itemConfig, self._indivTargetQty(key));
          priceEl.textContent = formatMoney(unitPrice) + ' / Stück';
        }
      });
    };

    // Zielmenge eines Individualisierungs-Artikels, WENN er aktiviert ist.
    // Banderole/Karte: unveraendert 1 pro Paket (boxQuantity) - sitzen aussen
    // am fertigen Paket bzw. liegen einmal bei. Aufkleber: sitzt auf JEDEM
    // einzelnen Glasdeckel, also 1 pro Glas - Gesamtmenge = Glasanzahl pro
    // Paket (boxCount, z. B. 4 bei der 4er-Box) mal Paket-Stueckzahl
    // (boxQuantity), nicht nur boxQuantity (Ringos Wunsch 27.09.2026:
    // "Anzahl der Aufkleber muss sich nach Anzahl der Gläser richten",
    // Banderole/Karte bleiben wie bisher).
    BundleFirmenkundenBuilder.prototype._indivTargetQty = function (key) {
      if (key === 'sticker') {
        return (this.state.boxCount || 0) * this.state.boxQuantity;
      }
      return this.state.boxQuantity;
    };

    // Laedt PhotoSwipe dynamisch nach (import(), auch in einem klassischen,
    // nicht-modularen <script> erlaubt) und legt EINE Lightbox-Instanz an,
    // die fuer alle drei Beispielbilder wiederverwendet wird - exakt das
    // Muster aus assets/theme.js.liquid (ProductGallery#photoswipe), nur
    // ohne die dortige Bindung an <media-carousel>/Varianten, da hier jedes
    // Bild fuer sich alleine steht (keine Vor-/Zurueck-Navigation noetig).
    // "vendor.min.js"/"photoswipe.min.js" sind bereits Theme-weite Assets -
    // hier wird also keine zusaetzliche Bibliothek nachgeladen.
    BundleFirmenkundenBuilder.prototype._getIndivLightbox = function () {
      if (this._indivLightboxPromise) return this._indivLightboxPromise;

      var assets = (this.config && this.config.assets) || {};
      if (!assets.vendorUrl || !assets.photoswipeUrl) {
        return Promise.reject(new Error('[bundle-firmenkunden] Lightbox-Assets fehlen in der Config'));
      }

      this._indivLightboxPromise = import(/* webpackIgnore: true */ assets.vendorUrl).then(function (mod) {
        var PhotoSwipeLightbox = mod.PhotoSwipeLightbox;
        var lightbox = new PhotoSwipeLightbox({
          pswpModule: function () {
            return import(/* webpackIgnore: true */ assets.photoswipeUrl);
          },
          bgOpacity: 1,
          closeSVG: BFK_LIGHTBOX_CLOSE_SVG,
          // Jeder Klick oeffnet genau EIN Bild (kein Karussell) - PhotoSwipes
          // Standard-Chrome fuer Galerien (Pfeile, Zaehler "1/1", Lupe fuer
          // manuelles Zoomen) waere hier nur verwirrender Leerlauf, siehe
          // Screenshot-Review 10.09.2026.
          arrowPrev: false,
          arrowNext: false,
          counter: false,
          zoom: false
        });
        // Zoom-Ausgangspunkt: vom angeklickten Thumbnail aus aufploppen statt
        // aus der Bildschirmmitte (dieselbe Optik wie die PDP-Galerie).
        lightbox.addFilter('thumbEl', function (thumbEl, data) {
          return data.thumbnailElement || thumbEl;
        });
        lightbox.init();
        return lightbox;
      });

      return this._indivLightboxPromise;
    };

    BundleFirmenkundenBuilder.prototype._openIndivLightbox = function (button) {
      var src = button.getAttribute('data-lightbox-src');
      if (!src) return;

      var width = parseInt(button.getAttribute('data-lightbox-width'), 10) || 0;
      var height = parseInt(button.getAttribute('data-lightbox-height'), 10) || 0;
      var alt = button.getAttribute('data-lightbox-alt') || '';
      var thumbImg = button.querySelector('img');

      var dataSource = [
        {
          src: src,
          width: width,
          height: height,
          alt: alt,
          msrc: thumbImg ? thumbImg.currentSrc || thumbImg.src : undefined,
          thumbnailElement: thumbImg
        }
      ];

      this._getIndivLightbox()
        .then(function (lightbox) {
          lightbox.loadAndOpen(0, dataSource);
        })
        .catch(function (err) {
          console.error('[bundle-firmenkunden] Lightbox konnte nicht geladen werden', err);
        });
    };

    BundleFirmenkundenBuilder.prototype._freshState = function () {
      return {
        step: 1,
        maxUnlockedStep: 1,
        boxSizeId: null,
        boxLabel: '',
        boxCount: 0,
        selections: {}, // variantId -> qty
        boxQuantity: this.config.boxQuantityMin || 1,
        // Individualisierung ist reines Upselling und rein binaer: entweder
        // ALLE Pakete dieser Konfiguration bekommen den Artikel (Menge =
        // boxQuantity), oder KEINS (Menge = 0) - keine frei waehlbare
        // Zwischenmenge, siehe _setIndivEnabled. Startet bewusst deaktiviert
        // (nicht vorausgewaehlt, Stand 31.08.2026).
        indiv: { sticker: 0, banderole: 0, card: 0, card_design: 0 },
        indivEnabled: { sticker: false, banderole: false, card: false, card_design: false },
        // Schritt 5 "Versand" (Anfrage von Markus Ebersberger, 27.09.2026).
        // "single" ist der Default (unveraendertes Verhalten: alle Pakete
        // dieser Konfiguration gehen an eine Adresse). shippingFile haelt
        // bewusst nur eine Referenz auf das ausgewaehlte File-Objekt fuer die
        // Validierung/Anzeige - der eigentliche Upload geschieht erst beim
        // Absenden in _addToCart ueber einen separaten multipart/form-data
        // Request (siehe dort).
        shippingMode: 'single',
        shippingAddressCount: (this.config.shipping && this.config.shipping.addressCountMin) || 1,
        shippingFile: null
      };
    };

    BundleFirmenkundenBuilder.prototype._cacheDom = function () {
      this.$navItems = this.querySelectorAll('[data-step-nav]');
      this.$steps = this.querySelectorAll('[data-step]');
      this.$boxCards = this.querySelectorAll('[data-box-id]');
      this.$productGrid = this.querySelector('[data-product-grid]');
      this.$progressBlock = this.querySelector('[data-progress-block]');
      this.$progressText = this.querySelector('[data-progress-text]');
      this.$progressBarFill = this.querySelector('[data-progress-bar-fill]');
      this.$boxQtyInput = this.querySelector('[data-box-qty-input]');
      this.$summary = this.querySelector('[data-summary]');
      this.$summaryToggle = this.querySelector('[data-summary-toggle]');
      this.$summaryBox = this.querySelector('[data-summary-box]');
      this.$summaryList = this.querySelector('[data-summary-list]');
      this.$summaryTotal = this.querySelector('[data-summary-total]');
      this.$addedMessage = this.querySelector('[data-added-message]');
      // Schritt 5 "Versand".
      this.$shippingOptions = this.querySelectorAll('[data-shipping-mode]');
      this.$shippingFields = this.querySelector('[data-shipping-individual-fields]');
      this.$shippingAddressCountInput = this.querySelector('[data-shipping-address-count]');
      this.$shippingFileInput = this.querySelector('[data-shipping-address-file]');
      this.$shippingFileName = this.querySelector('[data-shipping-file-name]');
      this.$shippingFeePriceEl = this.querySelector('[data-shipping-fee-price]');
      // Konsolidierte Leiste (auf Ringos Wunsch, 02.09.2026): EIN Zurueck-
      // und EIN Weiter/In-den-Warenkorb-Button statt vormals je einem Paar
      // pro Schritt-Section. Label/Sichtbarkeit/disabled-Status werden je
      // nach aktivem Schritt in _updatePrimaryAction() gesetzt.
      this.$prevStepBtn = this.querySelector('[data-prev-step]');
      this.$primaryActionBtn = this.querySelector('[data-primary-action]');
    };

    BundleFirmenkundenBuilder.prototype._bindEvents = function () {
      var self = this;

      if (this.$summaryToggle) {
        this.$summaryToggle.addEventListener('click', function () {
          self._toggleSummary();
        });
      }

      this.$boxCards.forEach(function (card) {
        card.addEventListener('click', function () {
          self._selectBox(card.getAttribute('data-box-id'));
        });
      });

      if (this.$prevStepBtn) {
        this.$prevStepBtn.addEventListener('click', function () {
          self._goToStep(self.state.step - 1);
        });
      }

      // Ein einziger Button uebernimmt "Weiter" (Schritt 1-4) UND "In den
      // Warenkorb" (Schritt 5, seit dem neuen Versand-Schritt 27.09.2026) -
      // welcher Modus gerade aktiv ist, steuert _updatePrimaryAction() ueber
      // Label/disabled, hier nur die Weiche anhand des aktuellen Schritts.
      if (this.$primaryActionBtn) {
        this.$primaryActionBtn.addEventListener('click', function () {
          if (self.state.step === 5) {
            self._addToCart();
          } else {
            self._goToStep(self.state.step + 1);
          }
        });
      }

      this.$navItems.forEach(function (item) {
        item.addEventListener('click', function () {
          var target = parseInt(item.getAttribute('data-step-nav'), 10);
          if (target <= self.state.maxUnlockedStep) self._goToStep(target);
        });
      });

      if (this.$boxQtyInput) {
        this.$boxQtyInput.addEventListener('change', function () {
          self._setBoxQuantity(self.$boxQtyInput.value);
        });
      }

      // Die Buttons stecken in einem echten <quantity-selector>/<input is="quantity-input">
      // (siehe assets/theme.js.liquid, QuantitySelector/QuantityInput) - dieses native
      // Theme-Element haengt beim Verbinden SELBST schon einen Klick-Handler an dieselben
      // Buttons und veraendert input.value direkt. Ein eigener Handler, der zusaetzlich
      // "+1"/"-1" rechnet, wuerde die Menge pro Klick verdoppeln. Stattdessen (wie in
      // variant-configurator.liquid) kurz warten, bis das native Element fertig ist, und
      // danach den bereits aktualisierten input.value uebernehmen.
      var boxQtyMinus = this.querySelector('[data-box-qty-minus]');
      var boxQtyPlus = this.querySelector('[data-box-qty-plus]');
      if (boxQtyMinus) {
        boxQtyMinus.addEventListener('click', function () {
          setTimeout(function () {
            self._setBoxQuantity(self.$boxQtyInput.value);
          }, 5);
        });
      }
      if (boxQtyPlus) {
        boxQtyPlus.addEventListener('click', function () {
          setTimeout(function () {
            self._setBoxQuantity(self.$boxQtyInput.value);
          }, 5);
        });
      }

      // Individualisierung ist bewusst binaer (Haekchen ja/nein, keine freie
      // Menge): entweder alle Pakete der Konfiguration bekommen den Artikel,
      // oder keins. Siehe _setIndivEnabled.
      this.querySelectorAll('[data-indiv-item]').forEach(function (row) {
        var key = row.getAttribute('data-indiv-item');
        var toggle = row.querySelector('[data-indiv-toggle]');
        if (!toggle) return;
        toggle.addEventListener('change', function () {
          self._setIndivEnabled(key, toggle.checked);
        });
      });

      // Beispielbilder (Aufkleber/Banderole/Karte) per Klick in einer
      // Lightbox oeffnen (Ringos Wunsch 10.09.2026) - nutzt dieselbe
      // PhotoSwipe-Instanz wie die PDP-Produktgalerie, siehe
      // _openIndivLightbox/_getIndivLightbox.
      this.querySelectorAll('[data-indiv-example-image]').forEach(function (button) {
        button.addEventListener('click', function () {
          self._openIndivLightbox(button);
        });
      });

      // Schritt 5 "Versand": Auswahl zwischen "eine Adresse" (Default) und
      // "Einzeladressen" - im zweiten Fall werden die Zusatzfelder
      // (Adressanzahl + Datei-Upload) eingeblendet, siehe _setShippingMode.
      this.$shippingOptions.forEach(function (btn) {
        btn.addEventListener('click', function () {
          self._setShippingMode(btn.getAttribute('data-shipping-mode'));
        });
      });

      if (this.$shippingAddressCountInput) {
        this.$shippingAddressCountInput.addEventListener('change', function () {
          self._setShippingAddressCount(self.$shippingAddressCountInput.value);
        });
      }

      // Bewusst KEINE automatische Auswertung der Datei (Ringos Entscheidung
      // 27.09.2026) - hier wird nur die Auswahl selbst gemerkt (fuer die
      // Validierung des "In den Warenkorb"-Buttons und den Dateinamen-
      // Hinweistext). Der eigentliche Upload passiert erst in _addToCart.
      if (this.$shippingFileInput) {
        this.$shippingFileInput.addEventListener('change', function () {
          var file = self.$shippingFileInput.files && self.$shippingFileInput.files[0];
          self.state.shippingFile = file || null;
          if (self.$shippingFileName) self.$shippingFileName.textContent = file ? file.name : '';
          self._updatePrimaryAction();
        });
      }
    };

    // Schritt 5 "Versand": Umschalten zwischen "eine Adresse" und
    // "Einzeladressen". Zeigt/versteckt die Zusatzfelder und aktualisiert
    // Zusammenfassung (Gebuehrenzeile) sowie den "In den Warenkorb"-Button
    // (Validierung siehe _shippingValid).
    BundleFirmenkundenBuilder.prototype._setShippingMode = function (mode) {
      this.state.shippingMode = mode;

      this.$shippingOptions.forEach(function (btn) {
        var isActive = btn.getAttribute('data-shipping-mode') === mode;
        btn.classList.toggle('is-selected', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (this.$shippingFields) this.$shippingFields.hidden = mode !== 'individual';

      this._updateSummary();
      this._updatePrimaryAction();
    };

    BundleFirmenkundenBuilder.prototype._setShippingAddressCount = function (value) {
      var min = (this.config.shipping && this.config.shipping.addressCountMin) || 1;
      var count = Math.max(min, parseInt(value, 10) || min);
      this.state.shippingAddressCount = count;
      if (this.$shippingAddressCountInput) this.$shippingAddressCountInput.value = String(count);

      this._updateSummary();
      this._updatePrimaryAction();
    };

    // "Einzeladressen" ist erst dann vollstaendig, wenn sowohl eine
    // (gueltige) Adressanzahl als auch eine Datei vorliegen - siehe Ringos
    // Entscheidung 27.09.2026 (Kunde gibt Anzahl manuell ein, keine
    // automatische Auswertung der Datei). "single" ist immer gueltig.
    BundleFirmenkundenBuilder.prototype._shippingValid = function () {
      if (this.state.shippingMode !== 'individual') return true;
      var min = (this.config.shipping && this.config.shipping.addressCountMin) || 1;
      var count = parseInt(this.state.shippingAddressCount, 10) || 0;
      return count >= min && !!this.state.shippingFile;
    };

    BundleFirmenkundenBuilder.prototype._selectBox = function (boxId) {
      var box = this.config.boxSizes.filter(function (b) {
        return b.id === boxId;
      })[0];
      if (!box) return;

      this.state.boxSizeId = box.id;
      this.state.boxLabel = box.label;
      this.state.boxCount = parseInt(box.count, 10) || 0;
      this.state.selections = {};

      // Aufkleber-Zielmenge haengt von der Glasanzahl (boxCount) ab - bei
      // einem Boxgroessen-Wechsel (z. B. zurueck zu Schritt 1 und andere
      // Groesse waehlen) mit bereits aktiviertem Aufkleber-Toggle die Menge
      // neu berechnen, sonst bliebe sie auf dem Stand der vorherigen
      // Boxgroesse haengen.
      if (this.state.indivEnabled.sticker) {
        this.state.indiv.sticker = this._indivTargetQty('sticker');
      }

      this.$boxCards.forEach(function (card) {
        card.classList.toggle('is-selected', card.getAttribute('data-box-id') === boxId);
      });

      this._renderProductGrid();
      this._updateSummary();
      this._updatePrimaryAction();

      // Direkt weiter zu Schritt 2 nach Auswahl (Ringos Wunsch, 02.09.2026)
      // - kein zusaetzlicher Klick auf "Weiter" mehr noetig. Kurze
      // Verzoegerung, damit der "is-selected"-Rahmen der geklickten Karte
      // noch sichtbar aufblitzt, bevor der Schritt wechselt. Vorherigen
      // Timer verwerfen, falls der Kunde sehr schnell zwischen Boxgroessen
      // hin- und herklickt.
      var self = this;
      window.clearTimeout(this._autoAdvanceTimer);
      this._autoAdvanceTimer = window.setTimeout(function () {
        if (self.state.boxSizeId === boxId) self._goToStep(2);
      }, 220);
    };

    BundleFirmenkundenBuilder.prototype._renderProductGrid = function () {
      var self = this;
      if (!this.$productGrid) return;
      this.$productGrid.innerHTML = '';

      this.config.products.forEach(function (product) {
        var qty = self.state.selections[product.variantId] || 0;

        var card = document.createElement('div');
        card.className = 'bfk-product-card';
        card.setAttribute('data-variant-id', product.variantId);

        // Eigener Wrapper mit position:relative (analog zu ".product-card__figure"
        // im normalen Produktgrid, siehe assets/theme.css), damit die Benefit-
        // Icon-Badge (".dumbbell--icon", Styles aus tzn_product_card.css) sich
        // korrekt relativ zum Bild positioniert statt relativ zur ganzen Karte
        // (Ringos Wunsch 10.09.2026: dasselbe Icon wie im Produktgrid auch hier).
        var figure = document.createElement('div');
        figure.className = 'bfk-product-card__figure';

        var img = document.createElement('img');
        img.className = 'bfk-product-card__image';
        img.loading = 'lazy';
        img.alt = product.title;
        if (product.image) img.src = product.image;
        figure.appendChild(img);

        if (product.dumbbellIcon) {
          var dumbbell = document.createElement('span');
          dumbbell.className = 'dumbbell--icon';
          var dumbbellImg = document.createElement('img');
          dumbbellImg.src = product.dumbbellIcon;
          dumbbellImg.alt = '';
          dumbbell.appendChild(dumbbellImg);
          figure.appendChild(dumbbell);
        }

        card.appendChild(figure);

        var title = document.createElement('div');
        title.className = 'bfk-product-card__title';
        title.textContent = product.title;
        card.appendChild(title);

        var price = document.createElement('div');
        price.className = 'bfk-product-card__price';
        price.textContent = formatMoney(product.price);
        card.appendChild(price);

        var footer = document.createElement('div');
        footer.className = 'bfk-product-card__footer';

        var stepper = document.createElement('quantity-selector');
        stepper.className = 'quantity-selector';

        var minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'quantity-selector__button quantity-selector__minus';
        minus.textContent = '−';
        minus.addEventListener('click', function () {
          self._setProductQuantity(product, (parseInt(qtyInput.value, 10) || 0) - 1);
        });

        var qtyInput = document.createElement('input');
        qtyInput.type = 'text';
        qtyInput.className = 'quantity-selector__input';
        qtyInput.inputMode = 'numeric';
        qtyInput.value = String(qty);
        // Manuelle Eingabe erlaubt (siehe _setProductQuantity, das den Wert
        // bei Bedarf auf die verbleibende Kapazitaet begrenzt statt den
        // Klick/Change kommentarlos zu ignorieren).
        qtyInput.addEventListener('change', function () {
          self._setProductQuantity(product, parseInt(qtyInput.value, 10) || 0);
        });
        qtyInput.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            qtyInput.blur();
          }
        });

        var plus = document.createElement('button');
        plus.type = 'button';
        plus.className = 'quantity-selector__button quantity-selector__plus';
        plus.textContent = '+';
        plus.addEventListener('click', function () {
          self._setProductQuantity(product, (parseInt(qtyInput.value, 10) || 0) + 1);
        });

        stepper.appendChild(minus);
        stepper.appendChild(qtyInput);
        stepper.appendChild(plus);
        footer.appendChild(stepper);
        card.appendChild(footer);

        if (qty > 0) card.classList.add('is-active');
        if (product.available === false) card.classList.add('is-disabled');

        self.$productGrid.appendChild(card);
      });

      this._updateProgress();
    };

    BundleFirmenkundenBuilder.prototype._totalSelected = function () {
      var total = 0;
      for (var id in this.state.selections) {
        total += this.state.selections[id];
      }
      return total;
    };

    BundleFirmenkundenBuilder.prototype._setProductQuantity = function (product, nextQty) {
      nextQty = Math.max(0, nextQty || 0);

      var currentTotal = this._totalSelected();
      var currentQty = this.state.selections[product.variantId] || 0;

      // Bei manueller Eingabe (statt Klick auf "+") kann nextQty die
      // verbleibende Kapazitaet der gewaehlten Boxgroesse ueberschreiten.
      // Statt den Wert kommentarlos zu verwerfen (verwirrend bei Tastatur-
      // eingabe), wird er auf das tatsaechliche Maximum begrenzt und immer
      // neu gerendert, damit das Feld den echten Wert zeigt.
      var remainingCapacity = this.state.boxCount - (currentTotal - currentQty);
      if (remainingCapacity < 0) remainingCapacity = 0;
      if (nextQty > remainingCapacity) nextQty = remainingCapacity;

      if (nextQty === 0) {
        delete this.state.selections[product.variantId];
      } else {
        this.state.selections[product.variantId] = nextQty;
      }

      this._renderProductGrid();
      this._updateSummary();
    };

    // Reiner Text-Baustein ("Noch 3 von 6 Produkten auswählen" /
    // "Alle 6 Produkte ausgewählt"), getrennt von _updateProgress() extrahiert,
    // damit sowohl der Fortschrittstext in der aufklappbaren Zusammenfassung
    // ALS AUCH das Kurzlabel der immer sichtbaren Leiste (siehe
    // _barLabelText) denselben Stand zeigen.
    BundleFirmenkundenBuilder.prototype._progressText = function () {
      var total = this._totalSelected();
      var target = this.state.boxCount || 0;
      var remaining = Math.max(target - total, 0);
      var isDone = total >= target && target > 0;
      var texts = this.config.texts || {};

      if (isDone) {
        return (texts.progressDoneTemplate || 'Alle {total} Produkte ausgewählt').replace('{total}', target);
      }
      if (remaining === 1) {
        // Kurze, konkrete Meldung statt generischem "Noch 1 von X" – faellt
        // auf das Plural-Template zurueck falls kein eigener Text gepflegt ist.
        return (texts.progressSingularTemplate || texts.progressTemplate || 'Noch 1 Produkt fehlt')
          .replace('{remaining}', remaining)
          .replace('{total}', target);
      }
      return (texts.progressTemplate || 'Noch {remaining} von {total} Produkten auswählen')
        .replace('{remaining}', remaining)
        .replace('{total}', target);
    };

    BundleFirmenkundenBuilder.prototype._updateProgress = function () {
      var total = this._totalSelected();
      var target = this.state.boxCount || 0;
      var isDone = total >= target && target > 0;

      // Ohne gewaehlte Boxgroesse (target 0) gibt es nichts anzuzeigen -
      // Block komplett ausblenden statt "Noch 0 von 0 Produkten auswählen".
      if (this.$progressBlock) this.$progressBlock.hidden = target <= 0;

      if (this.$progressBarFill) {
        var percent = target > 0 ? Math.min(100, Math.round((total / target) * 100)) : 0;
        this.$progressBarFill.style.width = percent + '%';
        this.$progressBarFill.parentElement.classList.toggle('is-complete', isDone);
      }

      if (this.$progressText) this.$progressText.textContent = this._progressText();

      this._updatePrimaryAction();
    };

    BundleFirmenkundenBuilder.prototype._setBoxQuantity = function (value) {
      var min = this.config.boxQuantityMin || 1;
      var qty = Math.max(min, parseInt(value, 10) || min);
      this.state.boxQuantity = qty;
      if (this.$boxQtyInput) this.$boxQtyInput.value = String(qty);

      // Fuer aktivierte Individualisierungs-Artikel gilt weiterhin "alle
      // Pakete" - wenn sich die Paket-Stueckzahl aendert, zieht die (binaer
      // aktivierte) Individualisierungsmenge automatisch mit (siehe
      // _indivTargetQty fuer die je nach Artikel unterschiedliche
      // Ziel-Berechnung). Deaktivierte Artikel bleiben unangetastet bei 0.
      var self = this;
      INDIV_KEYS.forEach(function (key) {
        if (self.state.indivEnabled[key]) {
          self.state.indiv[key] = self._indivTargetQty(key);
        }
      });

      this._updateSummary();
    };

    BundleFirmenkundenBuilder.prototype._setIndivEnabled = function (key, enabled) {
      // Unterhalb der Mindestmenge nicht aktivierbar (Schalter ist dann
      // ohnehin disabled, siehe _updateIndivAvailability - doppelte
      // Absicherung, falls der Aufruf programmatisch kommt).
      var itemConfig = this.config.individualization[key];
      var min = parseInt(itemConfig && itemConfig.minQuantity, 10) || 0;
      if (enabled && min > 0 && this._indivTargetQty(key) < min) enabled = false;
      this.state.indivEnabled[key] = enabled;
      this.state.indiv[key] = enabled ? this._indivTargetQty(key) : 0;
      this._updateSummary();
    };

    BundleFirmenkundenBuilder.prototype._goToStep = function (step) {
      step = Math.max(1, Math.min(5, step));

      this.state.step = step;
      this.state.maxUnlockedStep = Math.max(this.state.maxUnlockedStep, step);

      this.$steps.forEach(function (section) {
        var isTarget = parseInt(section.getAttribute('data-step'), 10) === step;
        section.hidden = !isTarget;
      });

      this.$navItems.forEach(function (item) {
        var itemStep = parseInt(item.getAttribute('data-step-nav'), 10);
        item.classList.toggle('is-active', itemStep === step);
        item.classList.toggle('is-done', itemStep < step);
        item.disabled = itemStep > this.state.maxUnlockedStep;
      }, this);

      if (this.$addedMessage) this.$addedMessage.hidden = true;

      // Leiste (Kurzlabel + Zurueck/Weiter-Buttons) haengt vom aktiven
      // Schritt ab - bei jedem Schrittwechsel neu bestimmen.
      this._updateSummary();
      this._updatePrimaryAction();

      // Ohne das hier landet man z. B. nach Schritt 2 (langes Produktgrid,
      // ggf. weit runtergescrollt beim letzten Klick) auf Schritt 3 (kurzer
      // Inhalt) mitten in einem leeren weissen Bereich, weil die Scroll-
      // position vom vorherigen, laengeren Schritt beibehalten wird (Ringos
      // Feedback 03.09.2026). Bei jedem Schrittwechsel zurueck zum Anfang
      // der Section scrollen.
      this._scrollToTop();
    };

    // Scrollt zum Seitenanfang DIESER Section (nicht zum Dokumentanfang -
    // falls die Section nicht ganz oben auf der Seite sitzt). Offset laesst
    // Platz fuer einen ggf. fixen/klebenden Header. Bewusst OHNE
    // "smooth"-Animation: bei manchen Browsern/Tabs (z. B. wenn der Tab im
    // Hintergrund gerendert wird) bleibt eine smooth-scrollTo-Animation
    // einfach stehen und der Sprung passiert dann gar nicht - genau der
    // Bug, den dieser Fix beheben soll. Ein sofortiger Sprung ist
    // garantiert zuverlaessig.
    BundleFirmenkundenBuilder.prototype._scrollToTop = function () {
      var target = this.closest('.bfk-section') || this;
      var rect = target.getBoundingClientRect();
      var offset = 96;
      var top = rect.top + window.pageYOffset - offset;
      window.scrollTo(0, Math.max(top, 0));
    };

    // Kurzlabel der immer sichtbaren Leiste: auf Schritt 2 (aktive
    // Produktauswahl) der Fortschrittstext ("Noch 3 von 6 Produkten..."),
    // sonst - sobald eine Boxgroesse gewaehlt ist - die Box-Zusammenfassung
    // ("4er Box × 2"). Ohne Auswahl bleibt der liquid-gerenderte
    // Default-Text (summary_empty) unangetastet (Rueckgabe null).
    BundleFirmenkundenBuilder.prototype._barLabelText = function () {
      if (!this.state.boxSizeId) return null;

      if (this.state.step === 2) {
        return this._progressText();
      }

      return (this.config.texts && this.config.texts.boxSummaryLabel || '{box} × {qty}')
        .replace('{box}', this.state.boxLabel)
        .replace('{qty}', this.state.boxQuantity);
    };

    // Steuert Sichtbarkeit/Label/disabled-Status des EINEN gemeinsamen
    // Zurueck- und Weiter/In-den-Warenkorb-Buttons in der Leiste, abhaengig
    // vom aktiven Schritt. Ersetzt die vormals pro Schritt-Section fest
    // verdrahteten Buttons (siehe Kommentar in _bindEvents).
    BundleFirmenkundenBuilder.prototype._updatePrimaryAction = function () {
      var texts = this.config.texts || {};
      var step = this.state.step;

      if (this.$prevStepBtn) this.$prevStepBtn.hidden = step === 1;

      if (!this.$primaryActionBtn) return;

      if (step === 5) {
        this.$primaryActionBtn.textContent = texts.addToCartLabel || 'Konfiguration in den Warenkorb';
        this.$primaryActionBtn.disabled = !this._shippingValid();
        return;
      }

      this.$primaryActionBtn.textContent = texts.nextLabel || 'Weiter';

      var disabled = false;
      if (step === 1) {
        disabled = !this.state.boxSizeId;
      } else if (step === 2) {
        var total = this._totalSelected();
        var target = this.state.boxCount || 0;
        disabled = !(target > 0 && total === target);
      }
      this.$primaryActionBtn.disabled = disabled;
    };

    // Analog zu _updateIndividualizationPriceLabels: zeigt den aktuell
    // gueltigen Stueckpreis der Versand-Bearbeitungsgebuehr an (haengt von
    // der eingegebenen Adressanzahl ab, falls Katalog-Mengenpreise
    // hinterlegt sind).
    BundleFirmenkundenBuilder.prototype._updateShippingFeePriceLabel = function () {
      if (!this.$shippingFeePriceEl) return;
      var feeConfig = this.config.shipping && this.config.shipping.fee;
      if (!feeConfig) return;
      var count = parseInt(this.state.shippingAddressCount, 10) || 0;
      var unitPrice = unitPriceForQty(feeConfig, count);
      this.$shippingFeePriceEl.textContent = formatMoney(unitPrice) + ' / Adresse';
    };

    // Mindestmengen der Individualisierung (Ringos Wunsch 20.10.2026):
    // Aufkleber erst ab 20 Glaesern, Banderole/Kartenbeilage ab 10 Paketen
    // (Werte aus den Section-Settings *_min_qty, per Config als
    // itemConfig.minQuantity). Verglichen wird mit derselben Zielmenge, die
    // spaeter in den Warenkorb geht (_indivTargetQty: Aufkleber = Glaeser,
    // Rest = Pakete). Unterhalb der Schwelle: Schalter gesperrt + Hinweis.
    // Sinkt die Menge unter die Schwelle, waehrend der Artikel aktiv ist,
    // wird er automatisch deaktiviert (Menge 0) - beim erneuten Erreichen
    // der Schwelle bleibt er aus, bis der Kunde ihn wieder einschaltet.
    // Laeuft am Anfang von _updateSummary, damit die Summe unten bereits
    // mit dem bereinigten state.indiv rechnet.
    BundleFirmenkundenBuilder.prototype._updateIndivAvailability = function () {
      var self = this;
      var texts = this.config.texts || {};
      // Ueber INDIV_KEYS statt ueber die DOM-Zeilen iterieren: auch ein
      // Artikel ohne gerenderte Zeile (Produkt im aktuellen Markt nicht
      // veroeffentlicht) muss im State sauber zurueckgesetzt werden.
      INDIV_KEYS.forEach(function (key) {
        var row = self.querySelector('[data-indiv-item="' + key + '"]');
        var itemConfig = self.config.individualization[key];
        var toggle = row && row.querySelector('[data-indiv-toggle]');
        var hint = row && row.querySelector('[data-indiv-min-hint]');
        var min = parseInt(itemConfig && itemConfig.minQuantity, 10) || 0;
        var current = self._indivTargetQty(key);
        var available = min <= 0 || current >= min;

        if (!available && self.state.indivEnabled[key]) {
          self.state.indivEnabled[key] = false;
          self.state.indiv[key] = 0;
        }
        if (toggle) {
          toggle.disabled = !available;
          if (!available) toggle.checked = false;
        }
        if (row) row.classList.toggle('is-unavailable', !available);

        if (hint) {
          var template = key === 'sticker'
            ? (texts.indivMinHintJars || 'Ab {min} Gläsern verfügbar – aktuell {current}')
            : (texts.indivMinHintPackages || 'Ab {min} Paketen verfügbar – aktuell {current}');
          hint.textContent = template.replace('{min}', min).replace('{current}', current);
          hint.hidden = available;
        }
      });
    };

    BundleFirmenkundenBuilder.prototype._updateSummary = function () {
      var self = this;
      var lines = [];
      var total = 0;

      this._updateIndivAvailability();
      this._updateIndividualizationPriceLabels();
      this._updateShippingFeePriceLabel();

      if (this.$summaryBox) {
        var labelText = this._barLabelText();
        // null = keine Auswahl - liquid-gerenderten Default-Text (summary_empty)
        // unangetastet lassen statt ihn zu ueberschreiben.
        if (labelText !== null) this.$summaryBox.textContent = labelText;
      }

      this.config.products.forEach(function (product) {
        var perBoxQty = self.state.selections[product.variantId];
        if (!perBoxQty) return;
        var lineQty = perBoxQty * self.state.boxQuantity;
        var lineTotal = lineQty * product.price;
        total += lineTotal;
        lines.push({ label: lineQty + '× ' + product.title, amount: formatMoney(lineTotal) });
      });

      INDIV_KEYS.forEach(function (key) {
        var qty = self.state.indiv[key];
        if (!qty) return;
        var itemConfig = self.config.individualization[key];
        if (!itemConfig) return;
        var unitPrice = unitPriceForQty(itemConfig, qty);
        var lineTotal = qty * unitPrice;
        total += lineTotal;
        lines.push({ label: qty + '× ' + itemConfig.title, amount: formatMoney(lineTotal) });
      });

      // Bearbeitungsgebuehr fuer "Versand an Einzeladressen" (nur wenn ein
      // Gebuehren-Produkt hinterlegt ist - ohne Produkt bleibt die Option
      // trotzdem nutzbar, siehe bfk_shipping_fee in der Section, nur ohne
      // Gebuehr in der Zusammenfassung).
      if (this.state.shippingMode === 'individual') {
        var feeConfig = this.config.shipping && this.config.shipping.fee;
        var addressCount = parseInt(self.state.shippingAddressCount, 10) || 0;
        if (feeConfig && feeConfig.variantId && addressCount > 0) {
          var feeUnitPrice = unitPriceForQty(feeConfig, addressCount);
          var feeLineTotal = addressCount * feeUnitPrice;
          total += feeLineTotal;
          lines.push({ label: addressCount + '× ' + feeConfig.title, amount: formatMoney(feeLineTotal) });
        }
      }

      if (this.$summaryList) {
        this.$summaryList.innerHTML = '';
        lines.forEach(function (line) {
          var li = document.createElement('li');
          var labelSpan = document.createElement('span');
          labelSpan.textContent = line.label;
          var amountSpan = document.createElement('span');
          amountSpan.textContent = line.amount;
          li.appendChild(labelSpan);
          li.appendChild(amountSpan);
          self.$summaryList.appendChild(li);
        });
      }

      if (this.$summaryTotal) this.$summaryTotal.textContent = formatMoney(total);

      // Label-/Summenlaenge kann die Zeilenumbrueche der Leiste veraendern
      // (z. B. laengeres Boxgroessen-Label auf schmalen Bildschirmen).
      this._syncSummaryBarHeight();
    };

    BundleFirmenkundenBuilder.prototype._toggleSummary = function () {
      if (!this.$summary || !this.$summaryToggle) return;
      var expanded = this.$summary.classList.toggle('is-expanded');
      this.$summaryToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      // Hoehe aendert sich durch die max-height-Transition erst ueber die
      // naechsten ~0.25s - sofort UND nach Abschluss der Transition neu
      // vermessen, sonst reserviert .bfk-main kurzzeitig zu wenig/zu viel
      // padding-bottom (siehe _syncSummaryBarHeight).
      this._syncSummaryBarHeight();
      var self = this;
      window.setTimeout(function () {
        self._syncSummaryBarHeight();
      }, 260);
    };

    // Setzt --bfk-summary-bar-height auf die tatsaechliche Gesamthoehe der
    // fix positionierten Leiste (Balken UND - auf Ringos Wunsch, 02.09.2026,
    // ist die Zusammenfassung jetzt standardmaessig aufgeklappt - die
    // aufklappbaren Details), damit sowohl _.bfk-main_ genug padding-bottom
    // reserviert (Schritt-Inhalte werden nicht verdeckt) ALS AUCH das
    // eTrusted-Guetesiegel (siehe CSS, "[id^=trustbadge-container-]") weit
    // genug hochgeschoben wird. Wird bewusst auf :root statt auf dieses
    // Custom Element gesetzt, weil das eTrusted-Widget als eigenes Element
    // direkt an <body> haengt, also AUSSERHALB dieses Elements liegt - eine
    // CSS-Custom-Property vererbt sich nur an Nachfahren im DOM-Baum.
    BundleFirmenkundenBuilder.prototype._syncSummaryBarHeight = function () {
      if (!this.$summary) return;
      var height = this.$summary.offsetHeight;
      if (height > 0) {
        document.documentElement.style.setProperty('--bfk-summary-bar-height', height + 'px');
      }
    };

    // Legt die Bearbeitungsgebuehr-Zeile fuer "Versand an Einzeladressen" an
    // (Menge = manuell eingegebene Adressanzahl) und haengt - sofern
    // ausgewaehlt - die Adressdatei als natives Shopify-Datei-Property an.
    // Absichtlich EIN eigener multipart/form-data-Request an /cart/add.js
    // (Browser setzt Content-Type/Boundary automatisch, daher kein eigener
    // "Content-Type"-Header) statt eines Eintrags im JSON-Batch weiter oben -
    // das JSON-Format kann keine Binaerdaten transportieren, und Shopify
    // laedt eine als File-Objekt uebergebene Property automatisch auf den
    // eigenen CDN hoch und speichert die URL als Property-Wert (keine
    // eigene App/kein eigener Server noetig). "Anzahl Lieferadressen" und
    // "Adressliste" bewusst OHNE fuehrenden Unterstrich, damit sie (wie
    // jede normale Property) auch im Warenkorb/Checkout fuer den Kunden
    // sichtbar bleiben - snippets/line-item.liquid rendert eine Property,
    // deren Wert "/uploads/" enthaelt, bereits automatisch als Link, es
    // sind also keine Snippet-Aenderungen fuer die Anzeige noetig. KEINE
    // automatische Auswertung des Dateiinhalts (Ringos Entscheidung
    // 27.09.2026) - die Datei wird unveraendert nur angehaengt.
    BundleFirmenkundenBuilder.prototype._addShippingFeeLine = function (setLabel) {
      var self = this;
      var feeConfig = this.config.shipping && this.config.shipping.fee;

      if (!feeConfig || !feeConfig.variantId) {
        // Kein Gebuehren-Produkt hinterlegt (siehe Kommentar zu
        // "product_shipping_fee" in der Section) - ohne Produkt/Variante
        // kann keine Cart-Line und damit auch keine Datei-Property angelegt
        // werden (Shopify-Properties haengen immer an einer Line, nie
        // eigenstaendig am Warenkorb). Bewusst kein Fehler/Abbruch: die
        // Versandoption bleibt trotzdem waehlbar, nur eben ohne
        // Gebuehrenzeile und ohne Datei-Anhang.
        console.warn('[bundle-firmenkunden] Kein Versand-Bearbeitungsgebuehr-Produkt hinterlegt - Adressdatei wurde NICHT an die Bestellung angehaengt.');
        return Promise.resolve();
      }

      var addressCount = parseInt(this.state.shippingAddressCount, 10) || 0;
      var formData = new FormData();
      formData.append('form_type', 'product');
      formData.append('id', feeConfig.variantId);
      formData.append('quantity', String(addressCount));
      formData.append('properties[_role]', 'versand-einzeladressen');
      formData.append('properties[_set]', setLabel);
      formData.append('properties[_box_label]', this.state.boxLabel);
      formData.append('properties[_box_quantity]', String(this.state.boxQuantity));
      formData.append('properties[Anzahl Lieferadressen]', String(addressCount));
      if (this.state.shippingFile) {
        formData.append('properties[Adressliste]', this.state.shippingFile, this.state.shippingFile.name);
        // Shopify legt eine hochgeladene Datei-Property unter einem
        // CDN-Hash-Dateinamen ab (nicht dem Originalnamen) - der echte, vom
        // Kunden vergebene Dateiname wird deshalb zusaetzlich als eigene,
        // versteckte Text-Property mitgeschickt (Namenskonvention
        // "_<Property>_dateiname", siehe snippets/line-item.liquid, das sie
        // NUR als Link-Beschriftung verwendet und dank des fuehrenden
        // Unterstrichs nicht als eigenen Listenpunkt anzeigt). Ringos
        // Feedback 27.09.2026: im Cart-Drawer stand nur der Hash-Dateiname.
        formData.append('properties[_Adressliste_dateiname]', this.state.shippingFile.name);
      }

      return fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (response) {
          return response.json();
        })
        .catch(function (error) {
          console.error('[bundle-firmenkunden] Versand-Bearbeitungsgebühr/Datei-Upload fehlgeschlagen', error);
        });
    };

    BundleFirmenkundenBuilder.prototype._addToCart = function () {
      var self = this;
      var totalSelected = this._totalSelected();

      if (!this.state.boxSizeId || totalSelected !== this.state.boxCount) {
        this._goToStep(2);
        return;
      }
      if (this.state.boxQuantity < (this.config.boxQuantityMin || 1)) {
        this._goToStep(3);
        return;
      }
      if (!this._shippingValid()) {
        this._goToStep(5);
        return;
      }

      var setId = uid();
      var setLabel = 'firmenkunden-' + this.state.boxSizeId + '-' + Date.now().toString(36);
      var items = [];

      this.config.products.forEach(function (product) {
        var perBoxQty = self.state.selections[product.variantId];
        if (!perBoxQty) return;
        items.push({
          id: product.variantId,
          quantity: perBoxQty * self.state.boxQuantity,
          properties: {
            _set_id: setId,
            _set: setLabel,
            _bundle_kind: 'firmenkunden',
            _role: 'box-item',
            _box_label: self.state.boxLabel,
            _box_quantity: self.state.boxQuantity
          }
        });
      });

      INDIV_KEYS.forEach(function (key) {
        var qty = self.state.indiv[key];
        var itemConfig = self.config.individualization[key];
        if (!qty || !itemConfig || !itemConfig.variantId) return;
        items.push({
          id: itemConfig.variantId,
          quantity: qty,
          properties: {
            _set_id: setId,
            _set: setLabel,
            _bundle_kind: 'firmenkunden',
            _role: 'individualisierung',
            _box_label: self.state.boxLabel,
            _box_quantity: self.state.boxQuantity,
            _indiv_label: itemConfig.title
          }
        });
      });

      if (!items.length) return;

      var addToCartBtn = this.$primaryActionBtn;
      if (addToCartBtn) addToCartBtn.disabled = true;

      fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          // "Versand an Einzeladressen": eigener, separater Request statt
          // eines weiteren Eintrags im obigen JSON-Batch, weil eine Datei
          // (multipart/form-data) sich nicht mit dem JSON-Format von
          // /cart/add.js mischen laesst UND weil diese Zeile bewusst OHNE
          // "_set_id"/"_bundle_kind: firmenkunden" auskommt (siehe
          // _buildShippingFeeFormData) - so greift die Cart-Transform-
          // Function (die genau diese beiden Properties fuer den Merge
          // prueft) hier nicht, und die Datei-Property bleibt auf dieser
          // eigenen, unveraenderten Zeile erhalten (im Bestell-Admin normal
          // sichtbar/downloadbar statt beim Merge verworfen zu werden).
          if (self.state.shippingMode === 'individual') {
            return self._addShippingFeeLine(setLabel);
          }
        })
        .then(function () {
          // Impacts "cart:change"-Listener (cart-drawer._onCartChanged)
          // erwartet das gerenderte HTML der Warenkorb-Sections unter
          // cart.sections[<section-id>] - ohne das warf er bisher einen
          // TypeError (20.10.2026 beim End-to-End-Test entdeckt). Die
          // Section-IDs sammelt das Theme selbst ueber dasselbe
          // "cart:prepare-bundled-sections"-Event wie beim normalen
          // Produkt-Formular (theme.js.liquid), das HTML kommt ueber die
          // Section Rendering API.
          var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
          var sectionsToBundle = [];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
          );
          var cartPromise = fetch(root + 'cart.js').then(function (response) { return response.json(); });
          var sectionsPromise = sectionsToBundle.length
            ? fetch(root + '?sections=' + encodeURIComponent(sectionsToBundle.join(',')))
                .then(function (response) { return response.json(); })
                .catch(function () { return {}; })
            : Promise.resolve({});
          return Promise.all([cartPromise, sectionsPromise]).then(function (results) {
            var cart = results[0];
            cart.sections = results[1] || {};
            return cart;
          });
        })
        .then(function (cart) {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } })
          );
          document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }));

          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.openDrawer === 'function') {
            cartDrawer.openDrawer();
            if (typeof cartDrawer._onCartRefresh === 'function') cartDrawer._onCartRefresh();
          }

          self._resetForNextConfiguration();
        })
        .catch(function (error) {
          console.error('[bundle-firmenkunden] add to cart failed', error);
        })
        .finally(function () {
          // Nicht stur auf "enabled" zuruecksetzen: bei Erfolg hat
          // _resetForNextConfiguration() den Schritt bereits auf 1
          // zurueckgesetzt, wo der Button (ohne erneute Boxgroessen-Wahl)
          // wieder disabled sein soll. _updatePrimaryAction() kennt den
          // fuer den jeweils AKTUELLEN Schritt richtigen Zustand.
          self._updatePrimaryAction();
        });
    };

    BundleFirmenkundenBuilder.prototype._resetForNextConfiguration = function () {
      this.state = this._freshState();

      this.$boxCards.forEach(function (card) {
        card.classList.remove('is-selected');
      });

      if (this.$boxQtyInput) this.$boxQtyInput.value = String(this.config.boxQuantityMin || 1);

      var self = this;
      INDIV_KEYS.forEach(function (key) {
        self._setIndivEnabled(key, false);
        var row = self.querySelector('[data-indiv-item="' + key + '"]');
        var toggle = row && row.querySelector('[data-indiv-toggle]');
        if (toggle) toggle.checked = false;
      });

      // Schritt 5 "Versand" auf den Ausgangszustand zuruecksetzen - inkl.
      // Datei-Input, das sich (anders als andere Formularfelder) nicht per
      // "value = ..." befuellen laesst, aber leeren schon per value = ''.
      this._setShippingMode('single');
      if (this.$shippingAddressCountInput) {
        this._setShippingAddressCount(this.config.shipping && this.config.shipping.addressCountMin);
      }
      if (this.$shippingFileInput) this.$shippingFileInput.value = '';
      if (this.$shippingFileName) this.$shippingFileName.textContent = '';

      this._renderProductGrid();
      this._updateSummary();

      this.$navItems.forEach(function (item) {
        var itemStep = parseInt(item.getAttribute('data-step-nav'), 10);
        item.disabled = itemStep > 1;
      });

      this._goToStep(1);

      if (this.$addedMessage) this.$addedMessage.hidden = false;
    };

    return BundleFirmenkundenBuilder;
  })(HTMLElement);

  if (!window.customElements.get('bundle-firmenkunden-builder')) {
    window.customElements.define('bundle-firmenkunden-builder', BundleFirmenkundenBuilder);
  }
})();






